import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { IcoValue, IcoOption } from './';

const OptionSelector = ({ name, onChange, options, value }) => (
  <div className={`option-selector ${name}`}>
    <Select
      autoBlur
      name={name}
      value={value}
      options={options}
      optionComponent={IcoOption}
      valueComponent={IcoValue}
      onChange={newObj => {
        onChange(name, newObj.value);
      }}
      clearable={false}
      searchable={false}
    />
  </div>
);

OptionSelector.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]).isRequired
};

export default OptionSelector;



// WEBPACK FOOTER //
// ./src/components/OptionSelector/OptionSelector.js


// WEBPACK FOOTER //
// webpack:///src/components/OptionSelector/OptionSelector.js